import React, { useState, useEffect } from 'react';
import { CompanyStyles } from './CompanyStyles';
import { CompanyHeader } from './CompanyHeader';
import { MobileDrawer } from './MobileDrawer';
import { AboutSection } from './AboutSection';
import { FrontierWaySection } from './FrontierWaySection';
import { LeadershipSection } from './LeadershipSection';
import { ResearchDispatchesSection } from './ResearchDispatchesSection';
import { FootprintSection } from './FootprintSection';
import { Footer } from '../landing/Footer';
import { BriefingModal } from '../landing/BriefingModal';
import { DispatchModal } from './DispatchModal';

// Company & Institutional Charter subpage (route: /company).
export default function CompanyPage() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [dispatchOpen, setDispatchOpen] = useState(false);
  const [dispatchContext, setDispatchContext] = useState('');

  // Plain "Request Briefing" triggers → shared grey box modal.
  const openBriefing = () => {
    setMobileOpen(false);
    setModalOpen(true);
  };

  // Dispatch cards → context modal with its own heading.
  const openDispatch = (context) => {
    setDispatchContext(context);
    setDispatchOpen(true);
  };

  useEffect(() => {
    document.title = 'Company & Institutional Charter | Frontier Deal OS™';
    if (!window.location.hash) window.scrollTo(0, 0);
  }, []);

  // Lock body scroll while an overlay is open.
  useEffect(() => {
    document.body.style.overflow = (mobileOpen || modalOpen || dispatchOpen) ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen, modalOpen, dispatchOpen]);

  // Scroll to an in-page anchor if the URL carries a hash (e.g. /company#leadership).
  useEffect(() => {
    if (!window.location.hash) return;
    const id = window.location.hash.slice(1);
    let tries = 0;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
      else if (tries++ < 20) setTimeout(tick, 100);
    };
    setTimeout(tick, 100);
  }, []);

  return (
    <div className="company-root min-h-screen bg-[#FBFBFB] text-stone-900 overflow-x-clip">
      <CompanyStyles />
      <CompanyHeader onOpenBriefing={openBriefing} onOpenDispatch={openDispatch} onToggleMobile={() => setMobileOpen((v) => !v)} />
      <MobileDrawer open={mobileOpen} onClose={() => setMobileOpen(false)} onOpenBriefing={openBriefing} />

      <AboutSection />
      <FrontierWaySection />
      <LeadershipSection />
      <ResearchDispatchesSection onOpenDispatch={openDispatch} />
      <FootprintSection onOpenBriefing={openBriefing} />
      <Footer onOpenBriefing={openBriefing} />

      <BriefingModal isOpen={modalOpen} onClose={() => setModalOpen(false)} inquiryType="" />
      <DispatchModal open={dispatchOpen} onClose={() => setDispatchOpen(false)} context={dispatchContext} />
    </div>
  );
}
